export default RAILS_ASSET_URL("/icon_60pt@2x.png")
